<template>
  <div class="main_bg">
    <div class="item_info" v-if="editForm.orderType === 2">
      <div class="item_title">
        <div class="title">售后订单</div>
        <div class="btnDivItem">
          售后原因：{{ editForm.afterSaleReason }}
        </div>
      </div>
    </div>
    <div class="item_info border_Warningcolor">
      <el-descriptions class="margin-top" title="订单信息" :column="3" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            订单号
          </template>
          {{ editForm.orderNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            所属门店
          </template>
          <span style="width: 140px; display: inline-block;">{{ editForm.belongStoreName }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            订单时间
          </template>
          {{ editForm.orderDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            门店快递单号
          </template>
          {{ editForm.storeKDNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            加工部快递单号
          </template>
          {{ editForm.jgbkdNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            订单状态
          </template>
          {{ editForm.stateStr }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            取镜时间
          </template>
          {{ editForm.getOrderDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            验光师
          </template>
          {{ editForm.yanGuangShi }}
        </el-descriptions-item>

        <el-descriptions-item span="2">
          <template slot="label">
            <i class="el-icon-tickets"></i>
            镜架信息
          </template>
          {{ editForm.jjInformation }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            加工类型
          </template>
          {{ editForm.machinTypeStr }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            确认人
          </template>
          {{ editForm.confirmUserName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            确认时间
          </template>
          {{ editForm.confirmTime }}
        </el-descriptions-item>
        <el-descriptions-item v-if="isShowWarehouseQty">
          <template slot="label">
            <i class="el-icon-tickets"></i>
            审核类型
          </template>
          {{ editForm.auditTypeStr }}
        </el-descriptions-item>
        <el-descriptions-item v-if="isShowWarehouseQty">
          <template slot="label">
            <i class="el-icon-tickets"></i>
            审核人
          </template>
          {{ editForm.auditUserName }}
        </el-descriptions-item>
        <el-descriptions-item v-if="isShowWarehouseQty">
          <template slot="label">
            <i class="el-icon-tickets"></i>
            审核时间
          </template>
          {{ editForm.auditTime }}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label">
            <i class="el-icon-tickets"></i>
            备注
          </template>
          {{ editForm.remark }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="item_info">
      <el-descriptions class="margin-top" title="顾客信息" :column="6" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            顾客姓名
          </template>
          <span style="width: 50px; display: inline-block;">{{ transformEmpty(customerInfo.name) }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            性别
          </template>
          <span style="width: 40px; display: inline-block;">{{ transformGender(customerInfo.gender) }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            年龄
          </template>
          <span style="width: 40px; display: inline-block;">{{ transformEmpty(customerInfo.age) }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            顾客电话
          </template>
          {{ transformEmpty(customerInfo.phone) }}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            所属门店
          </template>
          {{ transformEmpty(customerInfo.belongStoreName) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            (右眼)球镜
          </template>
          {{ transformEmpty(customerInfo.rParams.qiuJing) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            柱镜
          </template>
          {{ transformEmpty(customerInfo.rParams.zhuJing) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            轴位
          </template>
          {{ transformEmpty(customerInfo.rParams.zhouWei) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            瞳高
          </template>
          {{ transformEmpty(customerInfo.rParams.tongGao) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            瞳距
          </template>
          <span style="width: 40px; display: inline-block;">{{ transformEmpty(customerInfo.rParams.tongJu) }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            矫正视力
          </template>
          <span style="width: 40px; display: inline-block;">{{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            (左眼)球镜
          </template>
          {{ transformEmpty(customerInfo.lParams.qiuJing) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            柱镜
          </template>
          {{ transformEmpty(customerInfo.lParams.zhuJing) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            轴位
          </template>
          {{ transformEmpty(customerInfo.lParams.zhouWei) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            瞳高
          </template>
          {{ transformEmpty(customerInfo.lParams.tongGao) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            瞳距
          </template>
          {{ transformEmpty(customerInfo.lParams.tongJu) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            矫正视力
          </template>
          {{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="item_info border_Green">
      <div class="item_title">
        <div class="title">商品信息</div>
        <div class="btnDiv" v-if="!isShowWarehouseQty">
          <div class="btnDivItem">
            订单来源：{{ editForm.orderSourceStr }}
          </div>
          |
          <div class="btnDivItem">
            镜片类型：{{ editForm.eyeGlassTypeStr }}
          </div>
          |
          <div class="btnDivItem">
            订单类型：{{ editForm.orderTypeStr }}
          </div>
        </div>
        <div class="btnDiv" v-if="isShowWarehouseQty">
          <div class="btnDivItem">
            加工渠道：{{ editForm.machinChannelStr }}
          </div>
          |
          <div class="btnDivItem">
            镜片类型：{{ editForm.eyeGlassTypeStr }}
          </div>
          |
          <div class="btnDivItem">
            订单类型：{{ editForm.orderTypeStr }}
          </div>
        </div>
      </div>
      <el-table :data="goodsTableData" border stripe style="width: 100%;border-radius: 10px;"
        :header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
        <el-table-column prop="lr" label="左右眼" width="100">
          <template slot-scope="scope">
            <el-select v-model.number="scope.row.lr" placeholder="请选择" size="small" disabled>
              <el-option label="右眼" key="0" :value="0"></el-option>
              <el-option label="左眼" key="1" :value="1"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="goodsInfo.type" label="商品品牌" width="120"></el-table-column>
        <el-table-column prop="goodsInfo.name" label="商品名称">
        </el-table-column>
        <el-table-column prop="goodsInfo.qiuJing" label="球镜" width="90">
        </el-table-column>
        <el-table-column prop="goodsInfo.zhuJing" label="柱镜" width="90">
        </el-table-column>
        <el-table-column prop="zhouWei" label="轴位" width="120"></el-table-column>
        <!-- <el-table-column prop="price" label="单价" width="80">
        </el-table-column> -->
        <el-table-column prop="quantity" label="数量" width="60">
        </el-table-column>
        <el-table-column prop="goodsInfo.unit" label="单位" width="60">
        </el-table-column>
        <!-- <el-table-column prop="money" label="总价" width="80">
        </el-table-column> -->
        <el-table-column v-if="isShowWarehouseQty" prop="wareHouseQuantity" label="库存数量" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.wareHouseQuantity >= scope.row.quantity">{{
              scope.row.wareHouseQuantity
            }}</span>
            <span v-else style="display: block; background-color: #ff0000">{{
              scope.row.wareHouseQuantity
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="ADD"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { GetStoreOrderDetail } from "@/api/storeOrderApi.js";
import { getCustomerInfoDetail } from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
  props: [],
  data() {
    return {
      saveloading: false,
      editForm: {
        belongStoreKeyId: "",
        belongStoreName: "",
        orderNo: "",
        getOrderDate: "",
        JJInformation: "",
        customerKeyId: "",
        yanGuangShi: "",
        state: 0,
        stateStr: "",
        storeKDNo: "",
        jgbkdNo: "",
        orderDate: "",
        machinType: 1,
        machinTypeStr: "",
        auditType: 0,
        auditTypeStr: "",
        remark: "",
        eyeGlassType: 0,
        eyeGlassTypeStr: "",
      },
      rules: {},
      customerInfo: {
        name: "",
        phone: "",
        age: "",
        gender: -1,
        belongStoreName: "",
        lParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: "",
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
        rParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: "",
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
      },
      goodsTableData: [],
      goodsIndex: 1,
      isShowWarehouseQty: false,
      isAuditPass: true,
      machinTypeList: [],
    };
  },
  computed: {},
  watch: {},
  components: {},
  created() { },
  methods: {
    // 显示
    getDetailDialog(row, isShowWarehouseQty = false, type = 1) {
      this.isAuditPass = true;
      this.isShowWarehouseQty = isShowWarehouseQty;
      this.getMachinType();
      GetStoreOrderDetail({
        keyId: type == 1 ? row.keyId : row.linkOrderKeyId,
      }).then((res) => {
        if (res.code == 1) {
          getCustomerInfoDetail({ keyId: res.data.customerInfo.keyId }).then(
            (res) => {
              if (res.code == 1) {
                this.customerInfo = res.data;
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            }
          );
          this.goodsIndex = 1;
          this.editForm = res.data;
          this.goodsTableData = res.data.dtls;
          this.goodsTableData.forEach((item) => {
            item.rowNumber = this.goodsIndex++;
            if (item.wareHouseQuantity < item.quantity) {
              this.isAuditPass = false;
            }
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //转换性别
    transformGender(gender) {
      if (gender == 1) {
        return "男";
      } else if (gender == 0) {
        return "女";
      } else {
        return "--";
      }
    },
    //判断为空则用 -- 替代
    transformEmpty(obj) {
      if (obj == "" || obj == null || obj == undefined) {
        obj = "--";
      }
      return obj;
    },
    // 审核
    AuditOrer() {
      return this.isAuditPass;
    },
    // 获取加工类型
    getMachinType() {
      GetEnumConfigListByCode({
        code: "MachinType",
      })
        .then((res) => {
          if (res.code == 1) {
            this.machinTypeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取加工类型失败!");
        });
    },
  },
};
</script>
<style scoped lang="scss">
.main_bg {
  padding: 10px;
  margin-top: -15px;
}

.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
  border-left: 5px solid #ff9900;
}

.border_Green {
  border-left: 5px solid #00cc66;
}

.item_title {
  display: flex;
  width: 100%;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 10px;
  justify-content: space-between;

  .title {
    display: inline-block;
    unicode-bidi: isolate;
  }

  .btnDiv {
    display: block;
    unicode-bidi: isolate;
    word-break: break-all;
  }

  .btnDivItem {
    display: inline-block;
  }

  .text-red {
    display: block;
    background-color: #ff0000;
  }
}
</style>